import cn from 'classnames';
import React from 'react';

import styles from './styles.css';

export const Skeleton = () => {
  return (
    <div className={cn(styles.container)}>
      <div className={styles.sideLeft}>
        <div className={cn(styles.skeletonStripe, styles.fullHeight)} />
        <div className={cn(styles.skeletonStripe)} />
      </div>
      <div className={styles.sideRight}>
        <div className={cn(styles.skeletonStripe)} />
        <div className={cn(styles.skeletonStripe)} />
        <div className={cn(styles.skeletonStripe)} />
      </div>
    </div>
  );
};
